import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import logger from "../util/logger";
import moment from 'moment-timezone';
import ConfigService from "./config-service";

function dateTime(date, timeZone, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$format = _options.format,
      format = _options$format === void 0 ? 'LLL' : _options$format,
      _options$isRelative = _options.isRelative,
      isRelative = _options$isRelative === void 0 ? false : _options$isRelative,
      _options$isRelativeAl = _options.isRelativeAllowFuture,
      isRelativeAllowFuture = _options$isRelativeAl === void 0 ? false : _options$isRelativeAl;
  var displayDate;
  var _timeZone = timeZone; //If the supplied prop is a Date object, the date will be converted to 'GMT'. If it's a string, will create a moment with the zone set to 'GMT'

  var dateMoment = moment.tz(date, moment.ISO_8601, true, 'GMT');

  if (moment.tz.zone(_timeZone) === null) {
    logger.warn('The time zone provided has not been found. Time zone will default to "GMT"');
    _timeZone = 'GMT';
  }

  if (dateMoment === undefined || !dateMoment.isValid()) {
    displayDate = 'Invalid date';
    logger.warn('DateTime accpets an ISO 8601 valid string or a valid Date object for the date prop. Please see the Readme for information.');
  } else {
    if (isRelative) {
      if (isRelativeAllowFuture) {
        displayDate = dateMoment.tz(_timeZone).fromNow();
      } else {
        // Because we can't guarantee that the server and browser times will be in sync
        // Sometimes we were seeing things like "Last Updated in 2 minutes"
        // If the prop time (i.e. serverTime) is greater than the browser time then we default
        // to the browser time. Otherwise we use the server time;
        var serverTime = dateMoment;
        var browserTime = moment().tz('GMT');
        displayDate = serverTime.isAfter(browserTime) ? browserTime.tz(_timeZone).fromNow() : serverTime.tz(_timeZone).fromNow();
      }
    } else {
      displayDate = dateMoment.tz(_timeZone).format(format);
    }
  }

  return displayDate;
}

function modifiedBy(date, name) {
  return "Last modified " + dateTime(date, _valuesInstanceProperty(ConfigService).call(ConfigService).userTimeZone.name, {
    isRelative: true
  }) + " by " + name;
}

export default {
  dateTime: dateTime,
  modifiedBy: modifiedBy
};
//# sourceMappingURL=text-transform-service.js.map